module.exports = __webpack_public_path__ + "static/media/KD.eef3475c.svg";